// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found-content {\n  text-align: center;\n  margin-top: 9%;\n}\n.not-found-content .app-logo-loading {\n  width: 70px;\n  height: 70px;\n}", ""]);
// Exports
module.exports = exports;
